import { toInteger } from 'lodash';

export const stringHour = (time: string) => {
  const hour = toInteger(time);
  const min = (+time % 1) * 60;

  if (min === 0) {
    return `${hour}:${min}0`;
  }

  return `${hour}:${min}`;
};
